// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f66f7c2501b0d2a5f556","655":"aa1c1d978e22d7945458"}[chunkId] + ".js";
};